import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import postReducer from './postSlice';
import messageReducer from './messageSlice';
import adminReducer from './adminSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    posts: postReducer,
    messages: messageReducer,
    admin: adminReducer,
  },
});

export default store;
